import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Supabase 클라이언트 생성 (fetch timeout 설정 추가)
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: (url, options = {}) => {
      // 타임아웃 설정 (10초)
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000);

      return fetch(url, {
        ...options,
        signal: controller.signal,
      }).finally(() => clearTimeout(timeoutId));
    },
  },
});

export type Profile = {
  id: string;
  username: string;
  display_name: string | null;
  bio: string | null;
  avatar_url: string | null;
  points: number;
  reputation: number;
  created_at: string;
  updated_at: string;
};

export type Post = {
  id: string;
  user_id: string;
  type: 'feed' | 'study' | 'knowledge';
  category: string | null;
  title: string;
  content: string;
  tags: string[];
  bounty_points: number;
  status: 'open' | 'answered' | 'solved' | 'closed';
  likes_count: number;
  replies_count: number;
  views_count: number;
  created_at: string;
  updated_at: string;
  profiles?: Profile;
};

export type Job = {
  id: string;
  user_id: string;
  company: string;
  position: string;
  salary: string;
  location: string;
  experience: string;
  description: string;
  tags: string[];
  is_scraped: boolean;
  source_url: string | null;
  status: 'active' | 'closed' | 'filled';
  views_count: number;
  created_at: string;
  updated_at: string;
  profiles?: Profile;
};

export type Comment = {
  id: string;
  post_id: string;
  user_id: string;
  content: string;
  likes_count: number;
  is_accepted: boolean;
  created_at: string;
  updated_at: string;
  profiles?: Profile;
};
